<template>
    <div>
        <div style="with:100%" v-if="! hasComment">
            <a-textarea v-model="comment.content" placeholder="您可以在这里添加一些评价内容噢~" :rows="4" :style="{marginBottom:'10px'}"/>
            <a-rate v-model="comment.rate"/>
            <a-button type="primary" :style="{float:'right'}" :disabled="this.comment.rate == 0" @click="submitComment">提交</a-button>
        </div>
        <span>总共 {{ total }} 条评分</span>
        <a-list class="demo-loadmore-list" :loading="loading" itemLayout="horizontal" :dataSource="data" :style="{marginTop:'10px'}">
            <div
                    v-if="showLoadingMore"
                    slot="loadMore"
                    :style="{ textAlign: 'center', marginTop: '12px', height: '32px', lineHeight: '32px' }"
            >
                <a-spin v-if="loadingMore" />
                <a-button v-else @click="onLoadMore">加载更多内容</a-button>
            </div>
            <a-list-item slot="renderItem" slot-scope="item">
                <a slot="actions"><a-rate disabled :value="item.rate"/></a>
                <a-list-item-meta
                        :description="item.content"
                >
                    <a slot="title" @click="toHome(item.pickerId)">
                        {{item.pickerName}}
                        <a-icon v-if="item.pickerSex == 1" type="man" :style="{color:'#1E90FF'}" />
                        <a-icon v-if="item.pickerSex == 2" type="woman" :style="{color:'#eb2f96'}"/>
                    </a>
                    <a-avatar
                            slot="avatar"
                            :src="item.pickerAvatar"
                    />
                </a-list-item-meta>
            </a-list-item>
        </a-list>
    </div>
</template>

<script>
    import { TOPIC_COMMENT_POST, TOPIC_COMMENT_GET } from "@/components/constant/url_path";
    import qs from 'qs';

    export default {
        name: "TopicComment",
        props: ['topicId'],
        data() {
            return {
                hasComment: false,
                total: 0,
                comment: {
                    rate: 0,
                    content: undefined
                },
                page: {
                    pageNo: 1,
                    pageSize: 20
                },
                data: [],
                showLoadingMore: false,
                loadingMore: false,
                loading: false
            }
        },
        created() {
            this.fetchComments();
        },
        methods: {
            onLoadMore() {
                let _this = this;
                _this.page.pageNo = _this.page.pageNo + 1;
                _this.fetchComments();
            },
            submitComment() {
                let _this = this;
                _this.$axios.post(TOPIC_COMMENT_POST.replace("{topicId}", _this.topicId), _this.comment)
                .then(function (response) {
                    let code = response.data.code;
                    if (code == 200) {
                        _this.$message.success("提交成功");
                        _this.page.pageNo = 1;
                        _this.data = [];
                        _this.fetchComments();
                    } else {
                        _this.$message.info(response.data.message);
                    }
                }).catch(function () {
                    _this.$message.warn("评论加载失败");
                })
            },
            fetchComments() {
                let _this = this;
                _this.loadingMore = true;
                _this.$axios.get(TOPIC_COMMENT_GET.replace("{topicId}", _this.topicId).concat("?").concat(qs.stringify(_this.page)))
                .then(function (response) {
                    let code = response.data.code;
                    if (code == 200) {
                        _this.hasComment = response.data.result.hasComment;
                        let comments = response.data.result.comments;
                        for (let i = 0; i < comments.length; i++) {
                            _this.data.push(comments[i]);
                        }
                        _this.total = response.data.result.total;
                        _this.showLoadingMore = _this.total >= _this.page.pageSize * _this.page.pageNo;
                    } else {
                        _this.$message.info(response.data.message);
                    }
                    _this.loadingMore = false;
                }).catch(function () {
                    _this.loadingMore = false;
                    _this.$message.warn("评论加载失败");
                })
            },
            toHome(pickerId) {
                window.open('/user/'.concat(pickerId), '_target');
            },
        }
    }
</script>

<style scoped>

</style>